import { render, staticRenderFns } from "./FormDynamic.vue?vue&type=template&id=b791e28e&"
import script from "./FormDynamic.vue?vue&type=script&lang=js&"
export * from "./FormDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports